import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import '../css/AdminLogin.css'; // Make sure to create this CSS file

const AdminLogin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();

    // Trim spaces to prevent login errors
    const trimmedEmail = email.trim().toLowerCase();
    const trimmedPassword = password.trim();

    try {
      // Updated URL to use the working PHP proxy
      const res = await axios.post(
        '/proxy.php/backend/api/members/login',
        { email: trimmedEmail, password: trimmedPassword }
      );

      if (res.data.message === 'Login successful') {
        navigate('/AdminDashboard');
      } else {
        setMessage(res.data.message);
      }
    } catch (err) {
      console.log('Login error:', err.response?.data); // Debugging
      setMessage(err.response?.data?.message || 'Error logging in');
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <h2 className="login-title">Lenmo Admin Login</h2>
        <form onSubmit={handleLogin} className="login-form">
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className="login-input"
          />
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            className="login-input"
          />
          <button type="submit" className="login-button">Login</button>
        </form>
        {message && <p className="login-message">{message}</p>}
      </div>
    </div>
  );
};

export default AdminLogin;